import {
    MAINTENANCE_WARNINGS_EVENTS_OPEN_MODAL,
    CLEAR_REDUX
  } from "Redux/actionTypes";
  
  const INIT_STATE = {
    openModal: false,
    data: null,
    timezone: null
  };
  
  export default (state = INIT_STATE, action) => {
    switch (action.type) {
  
      case MAINTENANCE_WARNINGS_EVENTS_OPEN_MODAL:
        return { ...state, openModal: true, data: action.payload.data, timezone: action.payload.timezone };
  
      case CLEAR_REDUX:
        return ["","MAINTENANCE_WARNINGS_EVENTS"].includes(action.payload.option)
          ? action.payload.parameters ? { ...state, ...action.payload.parameters } : { ...INIT_STATE }
          : { ...state }
          
      default:
        return state;
    }
  };
  